import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient({});

export const ReactQueryProvider = (props) => (
  <QueryClientProvider client={queryClient}>
    {props.children}
  </QueryClientProvider>
);
